import React from "react";
import SVG from "./SVG";

const RssIcon: React.FunctionComponent<{}> = props => (
  <SVG
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 11a9 9 0 0 1 9 9"></path>
    <path d="M4 4a16 16 0 0 1 16 16"></path>
    <circle cx="5" cy="19" r="1"></circle>
  </SVG>
);

export default RssIcon;
